import type { UIStringsOverride } from "../i18n-ui.ts";

/** Hindi (hi) UI strings. */
export const hi: UIStringsOverride = {
  actions: {
    addToCursor: "Cursor में जोड़ें",
    addToVscode: "VS Code में जोड़ें",
    askAI: "इस पेज के बारे में AI से पूछें",
    connectMcp: "MCP से कनेक्ट करें",
    copied: "कॉपी किया गया!",
    copyClaudeCode: "Claude Code कमांड कॉपी करें",
    copyCode: "कोड कॉपी करें",
    copyCodex: "Codex कमांड कॉपी करें",
    copyMarkdown: "Markdown के रूप में कॉपी करें",
    copyServerUrl: "सर्वर URL कॉपी करें",
    edit: "GitHub पर संपादित करें",
    export: "एक्सपोर्ट करें",
    exportEpub: "EPUB में एक्सपोर्ट करें",
    exportPdf: "PDF में एक्सपोर्ट करें",
    generating: "जनरेट हो रहा है…",
    openIn: "{name} में खोलें",
    openInChat: "चैट में खोलें",
    scrollToTop: "ऊपर जाएँ",
  },
  ask: {
    ai: "AI",
    clear: "बातचीत साफ़ करें",
    close: "बंद करें",
    copy: "बातचीत कॉपी करें",
    empty: "दस्तावेज़ के बारे में एक प्रश्न पूछें।",
    error: "क्षमा करें, कुछ गलत हो गया।",
    label: "एक प्रश्न पूछें",
    placeholder: "एक प्रश्न पूछें…",
    send: "भेजें",
    tip: "सुझाव: चैट खोलने और बंद करने के लिए दबाएँ",
    title: "AI से पूछें",
    you: "आप",
  },
  banner: { dismiss: "घोषणा बंद करें" },
  changelog: {
    description: "उत्पाद अपडेट और रिलीज़ नोट्स।",
    showReleases: "{version} रिलीज़ दिखाएँ",
    title: "परिवर्तन लॉग",
  },
  content: { diagramError: "यह डायग्राम रेंडर नहीं हो सका।" },
  feedback: {
    no: "नहीं",
    question: "क्या यह पेज सहायक था?",
    thanks: "आपकी प्रतिक्रिया के लिए धन्यवाद!",
    yes: "हाँ",
  },
  languageSwitcher: { label: "भाषा", untranslated: "अनुवादित नहीं" },
  nav: {
    back: "वापस",
    breadcrumb: "ब्रेडक्रम",
    closeNavigation: "नेविगेशन बंद करें",
    deprecated: "अप्रचलित",
    featured: "फ़ीचर्ड",
    githubRepository: "GitHub रिपॉज़िटरी",
    navigation: "नेविगेशन",
    primary: "प्राथमिक",
    sections: "अनुभाग",
    toggleNavigation: "नेविगेशन टॉगल करें",
    toggleTheme: "रंग थीम टॉगल करें",
  },
  notFound: {
    description: "आप जिस पेज को खोज रहे हैं वह हमें नहीं मिला।",
    home: "होम पर वापस जाएँ",
    title: "पेज नहीं मिला",
  },
  page: {
    lastUpdated: "अंतिम अपडेट",
    next: "अगला",
    pagination: "पृष्ठांकन",
    previous: "पिछला",
    skipToContent: "सामग्री पर जाएँ",
  },
  search: {
    all: "सभी",
    allLanguages: "सभी भाषाएँ",
    askAi: "AI से पूछें",
    askAiHint: "AI से तुरंत जवाब पाएँ",
    button: "खोजें",
    devOnly: "खोज प्रोडक्शन बिल्ड में उपलब्ध है।",
    error: "कुछ गलत हो गया। कृपया फिर से कोशिश करें।",
    label: "दस्तावेज़ खोजें",
    navigate: "नेविगेट",
    noResults: "कोई परिणाम नहीं मिला।",
    open: "खोलें",
    placeholder: "दस्तावेज़ खोजें…",
    popular: "लोकप्रिय",
    preview: "प्रीव्यू",
    results: "परिणाम",
  },
  toc: { title: "इस पेज पर" },
};
